<template>
    <div>
        <row>
            <column md="4">
                <div class="sidebar-details">
                    <md-toolbar :md-elevation="2" class="p-0">
                        <md-list>
                            <md-list-item>
                                <md-avatar class="md-avatar-icon md-large md-primary">
                                    <img v-if="userDetails.profileImage != ''" :src="getImgUrl(userDetails.profileImage)" alt="Avatar">
                                    <md-ripple v-else>{{ formatName | uppercase }}</md-ripple>
                                </md-avatar>
                                <span class="md-list-item-text">{{ userDetails.firstName | capitalize }} {{ userDetails.lastName | capitalize }}</span>
                            </md-list-item>
                        </md-list>
                    </md-toolbar>
                    <md-list class="md-double-line">
                        <md-subheader>{{$t('address')}}</md-subheader>
                        <md-list-item>
                            <md-icon class="md-primary">location_on</md-icon>
                            <div class="md-list-item-text">
                                <span>{{ userDetails.address == '' ? 'None' : userDetails.address }}</span>
                            </div>
                        </md-list-item>

                        <md-divider></md-divider>

                        <md-subheader>{{$t('telephone')}}</md-subheader>
                        <md-list-item>
                            <md-icon class="md-primary">phone</md-icon>
                            <div class="md-list-item-text">
                                <span>{{ userDetails.telephone == '' ? 'None' : userDetails.telephone }}</span>
                            </div>
                        </md-list-item>

                        <md-divider></md-divider>

                        <md-subheader>{{$t('email')}}</md-subheader>
                        <md-list-item>
                            <md-icon class="md-primary">email</md-icon>
                            <div class="md-list-item-text">
                                <span>{{ userDetails.email }}</span>
                            </div>
                        </md-list-item>
                    </md-list>
                </div>
            </column>
            <column md="8">
                <form novalidate class="md-layout" @submit.prevent="validateUser">
                    <md-card class="md-layout-item mx-auto user-details">
                        <md-card-header>
                            <div v-show="message" v-html="alertMessage" :class="alertClass" class="alert fade show" role="alert"></div>
                            <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('your')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('account')}}</strong></h3>
                        </md-card-header>
                        <md-card-content class="ml-4 mr-4">
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('email')">
                                    <md-icon>email</md-icon>
                                    <label for="email">{{$t('your_email')}}</label>
                                    <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="true" />
                                    <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
                                </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('password')">
                                    <md-icon>vpn_key</md-icon>
                                    <label for="password">{{$t('your_password')}}</label>
                                    <md-input type="password" name="password" id="password" v-model="form.password" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.password.required">{{$t('required.password')}}</span>
                                </md-field>
                                </div>
                            </div>

                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('firstName')">
                                    <md-icon>account_circle</md-icon>
                                    <label for="first-name">{{$t('your_first_name')}}</label>
                                    <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.firstName.required">{{$t('required.first_name')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.firstName.minlength">{{$t('invalid.first_name')}}</span>
                                </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('lastName')">
                                    <md-icon>account_box</md-icon>
                                    <label for="last-name">{{$t('your_last_name')}}</label>
                                    <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.lastName" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.lastName.required">{{$t('required.last_name')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.lastName.minlength">{{$t('invalid.last_name')}}</span>
                                </md-field>
                                </div>
                            </div>

                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('country')">
                                    <md-icon>flag</md-icon>
                                    <label for="country">{{$t('your_country')}}</label>
                                    <md-select name="country" id="country" v-model="form.country" md-dense :disabled="sending">
                                    <md-option v-for="(country, index) in arr_country" :key="index" :value="index">{{country}}</md-option>
                                    </md-select>
                                    <span class="md-error">{{$t('required.country')}}</span>
                                </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('civility')">
                                    <md-icon>wc</md-icon>
                                    <label for="civility">{{$t('civility')}}</label>
                                    <md-select name="civility" id="civility" v-model="form.civility" md-dense :disabled="sending">
                                    <md-option value="Monsieur">{{$t('mr')}}</md-option>
                                    <md-option value="Madame">{{$t('mrs')}}</md-option>
                                    </md-select>
                                    <span class="md-error">{{$t('required.civility')}}</span>
                                </md-field>
                                </div>
                            </div>

                            <md-field :class="getValidationClass('birthYear')">
                                <md-icon>date_range</md-icon>
                                <label for="birthyear">{{$t('your_birth_year')}}</label>
                                <md-select name="birthYear" id="birthyear" v-model="form.birthYear" md-dense :disabled="sending">
                                    <md-option v-for="year in getRangeYear(1920)" :key="year" :value="year">{{year}}</md-option>
                                </md-select>
                                <span class="md-error">{{$t('required.birth_year')}}</span>
                            </md-field>
                        </md-card-content>
                        <md-progress-bar md-mode="indeterminate" v-if="sending" />
                        <div class="mt-0 mr-4 ml-4 mb-4">
                            <p class="small grey-text terms-of-use"><md-checkbox v-model="terms_of_use" class="md-primary" :disabled="sending || userDetails.accept_condition == true"></md-checkbox>{{$t('terms_of_conditions')}}.&nbsp;<a target="_blank" :href="termLink">{{$t('read_details')}}</a>.</p>
                            <p class="small grey-text terms-of-use newsletter" v-if="show_newsletter"><md-checkbox v-model="accept_newsletter" class="md-primary" :disabled="sending || userDetails.accept_newsletter == true"></md-checkbox>{{$t('accept_newsletter_model_comcolors')}}</p>
                            <div class="text-center mb-3">
                                <btn :disabled="sending" type="submit" size="sm" color="info" class="btn-rounded">{{$t('update')}}</btn>
                            </div>
                        </div>
                    </md-card>
                </form>
            </column>
        </row>
        <PaymentInfoModal />
    </div>
</template>

<script>
import axios from 'axios'
import { BASE_API } from '../helpers/base'
import { Row, Column, Btn, Card, CardBody } from 'mdbvue';
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import {getLoggedUser, updateUser, isTalentApp, isVenteApp, isTalentOrVenteApp} from '../services/User.service'
import PaymentInfoModal from '@/components/PaymentInfoModal'

export default {
    name: 'Account',
    mixins: [validationMixin],
    data: () => ({
        userDetails: {
            firstName: '',
            lastName: '',
            profileImage: '',
            email: '',
            address: '',
            telephone: '',
            accept_condition: '',
            accept_newsletter: ''
        },
        form: {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            country: null,
            civility: null,
            birthYear: null
        },
        arr_country: [],
        sending: false,
        message: false,
        terms_of_use: false,
        accept_newsletter: false,
        show_newsletter: isTalentApp(),
        alertMessage: '',
        alertClass: '',
    }),
    validations: {
        form: {
            firstName: {
                required,
                minLength: minLength(1)
            },
            lastName: {
                required,
                minLength: minLength(1)
            },
            email: {
                required,
                email
            },
            password: {
                required
            },
            country: {
                required
            },
            civility: {
                required
            },
            birthYear: {
                required
            }
        }
    },
    computed: {
        ...mapGetters(['currentUser']),
        formatName(){
            return `${this.userDetails.firstName.charAt(0)}${this.userDetails.lastName.charAt(0)}`;
        },
        termLink() {
          return (this.$route.params.locale == 'fr' || this.$route.params.locale == 'qc' ? 'https://www.comcolors.com/fr/rgpd/' : 'https://www.comcolors.com/fr/rgpd/')
        }
    },
    methods: {
        ...mapActions(['setUserDetails']),
        getImgUrl(pic) {
            return 'https://gestion.comcolors.com/img/avatars/'+pic
        },
        getUserData (){
            if(localStorage.getItem('userId')) {
                const userId=localStorage.getItem('userId');
                getLoggedUser(userId).then(response => {
                    this.setUserDetails(response.data.user_info);
                    const user = response.data.user_info
                    this.form.firstName = user.prenom
                    this.form.lastName = user.nom
                    this.form.email = user.email
                    this.form.password = user.motdepasse
                    this.form.country = user.pays
                    this.form.civility = user.civilite
                    this.form.birthYear = user.annee_naissance
                    this.userDetails.firstName = user.prenom
                    this.userDetails.lastName = user.nom
                    this.userDetails.profileImage = user.fichier
                    this.userDetails.email = user.email
                    this.userDetails.address = user.adresse
                    this.userDetails.telephone = user.telephone
                    this.terms_of_use = user.accepter_condition == 0 ? false : true
                    this.userDetails.accept_condition = user.accepter_condition
                    this.userDetails.accept_newsletter = user.newsletter_talent == 0 ? false : true
                    this.accept_newsletter = user.newsletter_talent == 0 ? false : true
                    console.log('UserData Account: ', user);
                }).catch(error => {
                    console.log(error.data.user_info);
                })
            }
        },
        saveUser () {
            this.sending = true
            this.message = false
            if(localStorage.getItem('userId')) {
                let data = {
                    prenom: this.form.firstName,
                    nom: this.form.lastName,
                    email: this.form.email,
                    motdepasse: this.form.password,
                    pays: this.form.country,
                    civilite: this.form.civility,
                    annee_naissance: this.form.birthYear,
                    newsletter_talent: (this.accept_newsletter == true ? 1 : 0)
                }
                const userId = localStorage.getItem('userId');
                if(this.terms_of_use){
                    updateUser(userId,data).then(response => {
                        console.log(response.data);
                        this.sending = false
                        this.message = true
                        this.alertMessage = response.data.message
                        this.alertClass = 'alert-success'
                        if (isVenteApp()) {
                          this.$router.push({name:'Questionnaire'});
                        } else {
                          this.$router.push({name:'QuestionnaireInstructions'});
                        }
                    }).catch(error => {
                        this.$store.dispatch('logout');
                        console.log(error.response);
                    })
                }else{
                    this.sending = false
                    this.message = true
                    this.alertClass = 'alert-danger'
                    this.alertMessage = this.$t('terms_of_use_error_message')
                    this.backToTop();

                    window.setTimeout(function(){
                        $('.alert').fadeIn(function(){
                            setTimeout(function(){
                                $(".alert").fadeOut(500, function(){
                                    $(this).hide();
                                });
                            }, 4000)
                        })
                    })
                }
            }
        },
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        validateUser () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.saveUser()
            }
        },
        arr_pays(){
            axios.get(`${BASE_API}/countries`)
            .then(response => {
                this.arr_country = response.data.arr_pays
            })
        },
        getRangeYear(start){
            const stop = (new Date()).getFullYear();
            return new Array(stop-start + 1).fill(start).map((n,i)=>n+i);
        },
        trackPageToFb(){
          if(isTalentOrVenteApp()){
            if (typeof fbq != "undefined") {
              fbq('track', 'Lead');
              console.log('Fire facebook pixel Lead');
            }
          }
        },
        backToTop(){
            if(this.terms_of_use == false){
                $('html,body').stop().animate({
                    scrollTop: $('.user-details').eq(0).offset().top - 55
                }, 'slow', 'swing');
            }else{
                $('html,body').stop().animate({
                    scrollTop: 0
                }, 'slow', 'swing');
            }
        }
    },
    components: {
        Btn, Row, Column, PaymentInfoModal
    },
    mounted(){
        this.getUserData();
        this.arr_pays();
        this.trackPageToFb();
    }
}
</script>

<style scoped>
.sidebar-details {
vertical-align: top;
overflow: auto;
border: 1px solid rgba(0,0,0,.12)
}
.sidebar-details .md-list-item-text {
white-space: normal;
}
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
ul.md-list.md-theme-default {
width: 100%;
}
@media (max-width: 767px){
.user-details .md-card-content {
margin: 0 !important;
}
}
.newsletter {
  justify-content: left;
  align-items: normal;
}
.terms-of-use {
  float:left;
  margin-left: 9%;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue